import { Image, View } from '@react-pdf/renderer';
import type { Style } from '@react-pdf/types';
import type { ReactElement } from 'react';

export type PdfImageProps = {
  src: string;
  viewStyle?: Style;
  imgStyle?: Style;
};

export const PdfImage = ({ src, viewStyle, imgStyle }: PdfImageProps): ReactElement => (
  <View style={viewStyle}>
    <Image src={src} style={imgStyle} />
  </View>
);
